import { defineMessages } from 'react-intl-next';

export const messages: {
	searchAcrossProducts: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	more: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreApps: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchAcrossProducts: {
		id: 'search_dialog_search_across_products',
		defaultMessage: 'Search all apps',
		description: 'Label for link to redirect users to search page',
	},
	more: {
		id: 'search_dialog_search_across_products.more',
		defaultMessage: 'more',
		description: 'Label to signify that a user can search for more connected apps',
	},
	moreApps: {
		id: 'search_dialog_search_across_products.more-apps',
		defaultMessage: '+ {more}',
		description:
			'Label showing additional connected apps available with a plus symbol prefix, e.g. "+ more"',
	},
});
